export const ADDED_TO_WISHLIST = 'ADDED_TO_WISHLIST';
